/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};

var isContentEditable = function isContentEditable(node) {
  return node.contentEditable === 'true';
};

var getTabindex = function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.


  if (isContentEditable(node)) {
    return 0;
  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || node.ownerDocument;

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isHidden = function isHidden(node, displayCheck) {
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  if (!displayCheck || displayCheck === 'full') {
    while (node) {
      if (getComputedStyle(node).display === 'none') {
        return true;
      }

      node = node.parentElement;
    }
  } else if (displayCheck === 'non-zero-area') {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  }

  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (isInput(node) || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'BUTTON') {
    var parentNode = node.parentElement;

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> as an immediate child of the disabled
        //  <fieldset>: if the node is in that legend, it'll be enabled even
        //  though the fieldset is disabled; otherwise, the node is in a
        //  secondary/subsequent legend, or somewhere else within the fieldset
        //  (however deep nested) and it'll be disabled
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);

          if (child.tagName === 'LEGEND') {
            if (child.contains(node)) {
              return false;
            } // the node isn't in the first legend (in doc order), so no matter
            //  where it is now, it'll be disabled


            return true;
          }
        } // the node isn't in a legend, so no matter where it is now, it'll be disabled


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }

  return true;
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function (candidate, i) {
    var candidateTabindex = getTabindex(candidate);

    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/focus-trap/dist/focus-trap.esm.js
/*!
* focus-trap 6.7.1
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  var containersContain = function containersContain(element) {
    return !!(element && state.containers.some(function (container) {
      return container.contains(element);
    }));
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (containersContain(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.tabbableGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container);

      if (tabbableNodes.length > 0) {
        return {
          container: container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }

      return undefined;
    }).filter(function (group) {
      return !!group;
    }); // remove groups with no tabbable nodes
    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (containersContain(target)) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = containersContain(target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's tabbable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
        var container = _ref.container;
        return container.contains(target);
      });

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    var target = getActualTarget(e);

    if (containersContain(target)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, 'onDeactivate');
      var onPostDeactivate = getOption(deactivateOptions, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(deactivateOptions, 'checkCanReturnFocus');

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = getOption(deactivateOptions, 'returnFocus', 'returnFocusOnDeactivate');

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map

;// CONCATENATED MODULE: ./node_modules/isinview/dist/index.es.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var defaultOptions = {
    once: false,
    threshold: 0,
};
var buildOptions = function (options) {
    return __assign(__assign({}, defaultOptions), options);
};
var observe = function (target, observer) {
    var targets = target instanceof Element ? [target] : target;
    for (var i = 0; i < targets.length; i++) {
        observer.observe(targets[i]);
    }
};
var createObserver = function (callback, options, condition) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var target = entry.target;
            if (entry.rootBounds !== null && condition(entry)) {
                callback(target, {
                    isAboveView: entry.boundingClientRect.bottom < entry.rootBounds.height / 2 && entry.boundingClientRect.top < 0,
                    isInView: entry.isIntersecting,
                    isBelowView: entry.boundingClientRect.top > entry.rootBounds.height / 2 && entry.boundingClientRect.bottom > entry.rootBounds.height,
                });
                if (options.once) {
                    observer.unobserve(target);
                }
            }
        });
    }, {
        threshold: options.threshold,
    });
    return observer;
};
function isSupported() {
    return 'IntersectionObserver' in window;
}
var isInView = function (target, callback, options) {
    if (options === void 0) { options = {}; }
    var completeOptions = buildOptions(options);
    var observer = createObserver(callback, completeOptions, function (entry) { return entry.isIntersecting; });
    observe(target, observer);
};
var isOutOfView = function (target, callback, options) {
    if (options === void 0) { options = {}; }
    var completeOptions = buildOptions(options);
    var observer = createObserver(callback, completeOptions, function (entry) { return !entry.isIntersecting; });
    observe(target, observer);
};


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/async-wait-until/dist/index.esm.js
class e extends Error{constructor(t){super(null!=t?`Timed out after waiting for ${t} ms`:"Timed out"),Object.setPrototypeOf(this,e.prototype)}}const t=(e,t)=>new Promise(((o,n)=>{try{e.schedule(o,t)}catch(e){n(e)}})),o={schedule:(e,t)=>{let o;const n=e=>{null!=e&&clearTimeout(e),o=void 0};return o=setTimeout((()=>{n(o),e()}),t),{cancel:()=>n(o)}}},n=50,r=5e3,c=Number.POSITIVE_INFINITY,l=(n,r,l)=>{var s,u;const i=null!==(s="number"==typeof r?r:null==r?void 0:r.timeout)&&void 0!==s?s:5e3,a=null!==(u="number"==typeof r?l:null==r?void 0:r.intervalBetweenAttempts)&&void 0!==u?u:50;let m=!1;const d=()=>new Promise(((e,r)=>{const c=()=>{m||new Promise(((e,t)=>{try{e(n())}catch(e){t(e)}})).then((n=>{n?e(n):t(o,a).then(c).catch(r)})).catch(r)};c()})),h=i!==c?()=>t(o,i).then((()=>{throw m=!0,new e(i)})):void 0;return null!=h?Promise.race([d(),h()]):d()};//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/js/packages/main-product.js




if (!customElements.get('product-details-modal')) {
  class ProductDetailsModal extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button.product__popup-link');
      this.modal = this.querySelector('.modal');
      this.closeButton = this.querySelector('.modal__close');
      this.modalBackground = this.querySelector('.modal__background');

      this.focusTrap = createFocusTrap(this.modal, {
        initialFocus: false,
      });

      this.bindEvents();
    }

    bindEvents() {
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.showModal();
      });

      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault(); 
        this.hideModal();
      });
      this.modalBackground.addEventListener('click', (event) => {
        event.preventDefault();
        this.hideModal();
      });
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hideModal();
      });
    }

    showModal() {
      document.body.classList.add('has-modal');
      this.modal.classList.add('modal--active');
      this.closeButton = this.querySelector('.modal__close');
      this.closeButton.focus();

      this.focusTrap.activate();
    }

    hideModal() {
      document.body.classList.remove('has-modal');
      this.modal.classList.remove('modal--active');

      this.focusTrap.deactivate();
    }
  }
  customElements.define('product-details-modal', ProductDetailsModal);
}

if (!customElements.get('media-slideshow')) {
  class MediaSlideshow extends HTMLElement {
    constructor() {
      super();

      this.slideshow = this.querySelector('.splide.media__main');
      this.slideshowList = this.slideshow.querySelector('.splide__list');
      this.slides = this.slideshow.querySelectorAll('.splide__slide');
      this.slideshowThumbnails = this.querySelector('.splide.media__thumbnails');
      this.mediaRatio = this.slideshow.dataset.mediaRatio;
      this.thumbnailPlacement = this.slideshow.dataset.thumbnailPlacement;

      this.mediaThumbnailsScrolling = this.querySelector('.media__thumbnails--scrolling');
      if (this.mediaThumbnailsScrolling) {
        this.mediaThumbnails = this.mediaThumbnailsScrolling.querySelectorAll(
          '.media__thumbnail'
        );
      }

      this.bindEvents();

      isInView(this, (target) => {
        this.initSlideshow();
      }, {
        once: true,
        threshold: 0.02,
      });

      // Lightbox and zoom (disabled for touch devices)
      if(theme.isTouchDevice()) return;
      const zoomEnabled = JSON.parse(this.dataset.zoom);
      const lightboxEnabled = JSON.parse(this.dataset.lightbox);
      
      if (zoomEnabled) {
        this.initZoom();
      }
      if (lightboxEnabled) {
        this.initLightbox();
      }      
    }

    bindEvents() {
      if (this.mediaThumbnails) {
        this.mediaThumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', (event) => this.selectThumbnail(event));
        })
      }
    }

    initSlideshow() {
      // Main
      this.slideshowOptions = JSON.parse(this.slideshow.dataset.options);

      // Media ratio
      switch (this.mediaRatio) {
        case 'square':
          this.slideshowOptions.heightRatio = 1;
          break;

        case 'portrait':
          this.slideshowOptions.heightRatio = 1.5;
          break;

        case 'landscape':
          this.slideshowOptions.heightRatio = .75;
          break;
      }

      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);
      })

      this.main = new theme.Splide(this.slideshow, this.slideshowOptions);
      this.main.on('move', (index, prev, dest) => {
        if (this.mediaRatio === 'adapt') {
          let indexId = index + 1;
          if (indexId < 10) {
            indexId = `0${indexId}`;
          }

          const destSlide = this.slideshow.querySelector(
            `#${this.main.root.id}-slide${indexId}`
          );
          const destSlideImage = destSlide.querySelector('.product__media-image');
          this.slideshowList.style.height = `${destSlideImage.offsetHeight}px`;
        }
      });

      this.main.on('moved', (newIndex, prevIndex, destIndex) => {
        if (this.mediaThumbnailsScrolling) {
          const activeClass = 'media__thumbnail--active';
          const prevActive = this.querySelector(`.${activeClass}`);
          const active = this.mediaThumbnailsScrolling.querySelector(
            `.media__thumbnail[data-index="${newIndex}"]`
          );

          prevActive.classList.remove(activeClass);
          active.classList.add(activeClass);

          active.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        }
      });

      this.main.on('mounted', () => {
        if (this.mediaRatio === 'adapt') {
          this.onResize();

          const activeSlide = this.slideshow.querySelector(
            '.splide__slide.is-active'
          );
        }
      });

      // Thumbnails
      if (this.slideshowThumbnails) {
        this.slideshowThumbnailsOptions = JSON.parse(this.slideshowThumbnails.dataset.options);
        this.thumbnails = new theme.Splide(
          this.slideshowThumbnails,
          this.slideshowThumbnailsOptions
        );

        this.main.sync( this.thumbnails );
      }

      this.main.mount();

      if (this.slideshowThumbnails) {
        this.thumbnails.mount();

        // Resize thumbnail container if smaller than overall slideshow
        const track = this.slideshowThumbnails.querySelector('.splide__track');
        const list = this.slideshowThumbnails.querySelector('.splide__list');
        const thumbnails = list.querySelectorAll('.splide__slide');

        const trackStyles = getComputedStyle(track);
        const trackMarginLeft = parseInt(trackStyles.marginLeft);
        const trackMarginRight = parseInt(trackStyles.marginRight);

        this.thumbnailsContainer = this.querySelector(
          '.media__thumbnails-container'
        );

        this.mediaResizeObserver = new ResizeObserver((entries) => {
          const target = entries[0].target;

          let thumbnailsWidths = 0;
          thumbnails.forEach((thumbnail, index) => {
            const thumbnailStyles = getComputedStyle(thumbnail);
            let thumbMargin = 0;
            if (index + 1 !== thumbnails.length) {
              thumbMargin =
                parseFloat(thumbnailStyles.marginLeft) +
                parseFloat(thumbnailStyles.marginRight);
            }
            
            thumbnailsWidths =
              thumbnailsWidths + thumbnail.offsetWidth + thumbMargin;
          });

          const containerWidth =
            thumbnailsWidths + trackMarginLeft + trackMarginRight;

          if (containerWidth < target.offsetWidth) {
            this.thumbnailsContainer.style.width = `${containerWidth}px`;
            this.thumbnails.refresh();
          } else {
            this.thumbnailsContainer.style.width = 'auto';
          }
        });
        this.mediaResizeObserver.observe(this);
      }
    }

    initZoom() {
      const mediaSlides = [...this.slides].filter((slide) => {
        return slide.dataset.mediaType === 'image';
      });

      const slideWidth = mediaSlides[0].offsetWidth;
      this.setAttribute('data-zoom-enabled', true);

      mediaSlides.forEach((slide) => {
        const media = slide.querySelector('.product__media-image');
        let maxZoomWidth = Number(media.dataset.width);
        if (maxZoomWidth > 1400) maxZoomWidth = 1400;

        if (slideWidth > maxZoomWidth) {
          slide.classList.add('zoom-disabled');
          return;
        }
        
        slide.style.backgroundImage = `url(${media.src})`;

        slide.addEventListener('mousemove', (event) => {
          const media = event.currentTarget.querySelector(
            '.product__media-image'
          );
          const maxZoomWidth = Number(media.dataset.width);

          const zoomer = event.currentTarget;
          let offsetX;
          let offsetY;

          event.offsetX ? (offsetX = event.offsetX) : (offsetX = event.touches[0].pageX);
          event.offsetY ? (offsetY = event.offsetY) : (offsetY = event.touches[0].pageY);

          const x = (offsetX / zoomer.offsetWidth) * 100;
          const y = (offsetY / zoomer.offsetHeight) * 100;
          zoomer.style.backgroundPosition = `${x}% ${y}%`;
        });
      });
    }

    initLightbox() {
      const mediaSlides = [...this.slides].filter((slide) => {
        return slide.dataset.mediaType === 'image';
      });
      mediaSlides.forEach((slide) => {
        const media = slide.querySelector('.product__media-image');
        media.classList.add('cursor-pointer');
        media.addEventListener('click', (event) => {
          this.showLightbox(event.target);
        });
      });

      this.modal = this.querySelector('.modal');
      this.closeButton = this.querySelector('.modal__close');
      this.modalBackground = this.querySelector('.modal__background');
      this.modalContainer = this.querySelector('.modal__container');

      this.focusTrap = createFocusTrap(this.modal, {
        initialFocus: false,
      });

      // Events
      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault(); 
        this.closeLightbox();
      });
      this.modalBackground.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeLightbox();
      });
      this.modalContainer.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeLightbox();
      });
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.closeLightbox();
      });
    }

    showLightbox(image) {
      if (!image) return;

      const imageClone = image.cloneNode(true);

      imageClone.setAttribute('sizes', '100vw');
      imageClone.classList.remove('cursor-pointer');
      const modalContainer = this.modal.querySelector('.modal__container');
      modalContainer.replaceChildren(imageClone);

      document.body.classList.add('has-modal');
      this.modal.classList.add('modal--active');
      this.closeButton = this.querySelector('.modal__close');
      this.closeButton.focus();

      this.focusTrap.activate();
    }

    closeLightbox() {
      document.body.classList.remove('has-modal');
      this.modal.classList.remove('modal--active');

      this.focusTrap.deactivate();
    }

    disableDrag() {
      this.main.options = {
        drag: false,
        keyboard: false,
      }
    }

    enableDrag() {
      this.main.options = {
        drag: true,
        keyboard: true,
      };
    }

    selectThumbnail(event) {
      const activeClass = 'media__thumbnail--active';
      const prevActive = this.querySelector(`.${activeClass}`);
      const active = event.currentTarget;
      const index = Number(active.dataset.index);

      prevActive.classList.remove(activeClass);
      active.classList.add(activeClass);

      this.main.go(index);
    }

    setActiveMedia(mediaId) {
      const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeSlide) return;

      const activeSlideIndex = Number(activeSlide.dataset.slideIndex);
      this.main.go(activeSlideIndex);
    }

    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        const activeSlideImage = this.slideshow.querySelector(
          '.splide__slide.is-active .product__media-image'
        );
        if ( this.main.state.is( theme.Splide.STATES.IDLE ) ) {
          this.slideshowList.style.height = `${activeSlideImage.offsetHeight}px`;
        }
      });

      this.slideshowResizeObserver.observe(this.slideshow);
    }
  }
  customElements.define('media-slideshow', MediaSlideshow);
}

if (
  !customElements.get('variant-selects') &&
  !customElements.get('variant-radios')
) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.variantFetchData = [];
      this.section = this.closest('div[data-section-id]');
      this.variants = this.getVariantData();
      this.addEventListener('change', this.onVariantChange);
      
      this.buildOptionsMap();
    }

    buildOptionsMap() {
      this.optionsMap = {};
      if (!this.variants) return;
      
      this.variants.forEach((variant) => {
        if (variant.available) {
          this.optionsMap['root'] = this.optionsMap['root'] || [];
          this.optionsMap['root'].push(variant.option1);

          const uniqueRootOptionsSet = new Set(this.optionsMap['root']);
          this.optionsMap['root'] = Array.from(uniqueRootOptionsSet);

          if (variant.options.length > 1) {
            const key = variant.option1;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option2);

            const uniqueOption1Set = new Set(this.optionsMap[key]);
            this.optionsMap[key] = Array.from(uniqueOption1Set);
          }

          if (variant.options.length === 3) {
            const key = `${variant.option1}/${variant.option2}`;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option3);

            const uniqueOption2Set = new Set(this.optionsMap[key]);
            this.optionsMap[key] = Array.from(uniqueOption2Set);
          }
        }
      });
      this.updateOptionsInSelector();
    }

    updateOptionsInSelector() {
      if (this.nodeName === 'VARIANT-SELECTS') return;
      
      const options = this.variants[0].options;
      for (let i in options) {
        let key;
        let fieldset;
        if (i == 0) {
          key = 'root';
        } else if (i == 1) {
          key = this.querySelectorAll('fieldset')[0].querySelector(
              'input:checked'
            ).value;
        } else {
          key = `${this.querySelectorAll('fieldset')[0].querySelector(
            'input:checked'
          ).value}/${this.querySelectorAll('fieldset')[1].querySelector(
            'input:checked'
          ).value}`;
        }
        const selector = this.querySelectorAll('fieldset')[i];

        const initialValue = selector.querySelector('input:checked').value;
        const availableOptions = this.optionsMap[key];

        if (!availableOptions) return;

        const variantSelectors = selector.querySelectorAll('input');
        variantSelectors.forEach((variantSelector) => {
          if (availableOptions.includes(variantSelector.value)) {
            // variantSelector.disabled = false;
            variantSelector.classList.remove('product-form__radio--disabled');
          } else {
            // variantSelector.disabled = true;
            variantSelector.classList.add('product-form__radio--disabled');
          }
        });

        if (!availableOptions.includes(initialValue) && this.dataset.disableSoldout == 'true') {
          const availableInput = selector.querySelector(`input[value="${availableOptions[0]}"]`);
          // const availableLabel = selector.querySelectorAll(`label[for="${availableInput[0].id}"]`);
          availableInput.click();
          break;
        }
      }
      
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariants();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateOptionsInSelector();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      );
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateVariants() {
      // Update swatches
      const swatches = this.querySelectorAll('.product-form__input.swatches');
      swatches.forEach((swatch) => {
        const swatchName = swatch.querySelector('.product-form__swatch-name');
        const radios = swatch.querySelectorAll('input[type="radio"]');
        const value = Array.from(radios).find(radio => radio.checked).value;

        swatchName.textContent = value;
      });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtons = productForm.querySelector('.product-form__buttons');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;

        if (modifyClass) {
          addButtons.dataset.enabled = false;
        }
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = theme.strings.addToCart;
        addButtons.dataset.enabled = true;
      }

      if (!modifyClass) return;
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      if (!this.section) return;
      const productForm = this.section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    setUnavailable() {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);

      if (!addButton) return;
      addButtonText.textContent = theme.strings.unavailable;
      if (price) price.classList.add('hidden');
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaSlideshow = document.getElementById(
        `MediaSlideshow-${this.dataset.section}`
      );
      mediaSlideshow.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`
      );
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }

    renderProductInfo() {
      const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
      const filterDataUrl = (element) => element.url === url;

      this.variantFetchData.some(filterDataUrl)
        ? this.renderProductInfoFromCache(filterDataUrl)
        : this.renderProductInfoFromFetch(url);
    }

    renderProductInfoFromCache(filterDataUrl) {
      const html = this.variantFetchData.find(filterDataUrl).html;
      this.renderProductPrice(html);
      this.renderProductButtons(html);
      this.renderProductLiquid(html);
    }

    renderProductInfoFromFetch(url) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          this.variantFetchData = [...this.variantFetchData, {html, url}];
          this.renderProductPrice(html);
          this.renderProductButtons(html);
          this.renderProductLiquid(html);
        });
    }

    renderProductPrice(html) {
      const id = `price-${this.dataset.section}`;
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const destination = document.getElementById(id);
      const source = parsedHTML.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
    }

    renderProductLiquid(html) {
      const sourceLiquidBlocks = document.querySelectorAll(
        `.product__liquid[data-section="${this.dataset.section}"]`
      );
      if (sourceLiquidBlocks.length === 0) return;

      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const liquidBlocks = parsedHTML.querySelectorAll('.product__liquid');
      liquidBlocks.forEach((liquidBlock) => {
        const blockId = liquidBlock.dataset.blockId;
        const sourceBlock = document.querySelector(
          `.product__liquid[data-section="${this.dataset.section}"][data-block-id="${blockId}"]`
        );
        sourceBlock.innerHTML = liquidBlock.innerHTML;
      });
    }

    renderProductButtons(html) {
      const price = document.getElementById(`price-${this.dataset.section}`);

      if (price) price.classList.remove('hidden');
      this.toggleAddButton(
        !this.currentVariant.available,
        theme.strings.soldOut
      );
    }

    updateShareUrl() {
      const shareUrl = `${theme.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
      const shareText = encodeURI(this.dataset.sectionText);

      const facebookLink = this.section.querySelector(
        '.social-share__link--facebook'
      );
      const twitterLink = this.section.querySelector(
        '.social-share__link--twitter'
      );
      const pinterestLink = this.section.querySelector(
        '.social-share__link--pinterest'
      );

      if (facebookLink) {
        facebookLink.setAttribute(
          'href',
          `https://www.facebook.com/sharer.php?u=${shareUrl}`
        );
      }
      if (twitterLink) {
        twitterLink.setAttribute(
          'href',
          `https://twitter.com/share?url=${shareUrl}&text=${shareText}`
        );
      }
      if (pinterestLink) {
        pinterestLink.setAttribute(
          'href',
          `https://pinterest.com/pin/create/bookmarklet/?url=${shareUrl}&description=${shareText}`
        );
      }
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }
  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', (event) =>
        this.onSubmitHandler(event)
      );
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const loadingClass = 'loading';

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains(loadingClass)) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add(loadingClass);
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = theme.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove(loadingClass);
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageContainer =
        this.errorMessageContainer ||
        this.querySelector('.product-form__error-container');
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageContainer.querySelector(
          '.product-form__error-message'
        );
      this.errorMessageContainer.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
  customElements.define('product-form', ProductForm);
}

/******/ })()
;